<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                    <toolBar :loading.sync="mainLoading"
                             :menuId="menu_id"
                             :searchData="searchData"
                             @search="search"
                             @excel="excel"
                             @monthCheck="monthCheck">
                    </toolBar>

                <el-table
                        ref="table"
                        :data="dataList"
                        height="400"
                        style="width: 100%;"
                        highlight-current-row
                        :header-cell-style="headerStyle"
                        :cell-style="cellStyle"
                        row-key="id"
                        border>
                    <el-table-column
                            type="index"
                            :index="(pageInfo.page-1) * pageInfo.pagesize+1"
                            label="序号"
                            align="center"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="yearMonth"
                            label="结账年月"
                            align="left"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="startNum"
                            label="期初总数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="startTotal"
                            label="期初总金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="intoNum"
                            label="入库总数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="into总Total"
                            label="入库金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="outNum"
                            label="出库总数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="outTotal"
                            label="出库总金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="lossNum"
                            label="损益总数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="lossTotal"
                            label="损益总金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="endNum"
                            label="期末总数量"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="endTotal"
                            label="期末总金额"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="makeBy"
                            label="结账人"
                            align="center"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="makeDate"
                            label="结账日期"
                            align="center"
                            width="200">
                    </el-table-column>
                </el-table>
                <div class="pagStyle">
                    <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import toolBar from '@/components/page/sysmain/monthcheck/toolBar'
    import pagination from "@/components/tools/table/pagination";

    export default {
        name: "monthed",
        props: ['menuData'],
        components: {pagination, toolBar},
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData:{}
                },

                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                }
            }
        },
        methods: {
            async getListData() {

                this.loading = true;
                let param = {
                    url: "/productmonth/list",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.data;
                    this.pageInfo.total = data.data.count;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            excel(data) {
                this.searchData.formData = data;

                let param = {
                    url: "/productmonth/excel",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                this.$store.dispatch('pubMethod', param)
            },
            async monthCheck(yearMonth) {

                this.dialogLoading = true;
                let param = {
                    yearMonth:yearMonth,
                }
                console.info(param)
                const data_re = await this.$sqlOpt.save.saveNoToken(param, "/monthed/monthlyCheck");
                if (data_re.infoCode === '0') {
                    this.$message.success("结账成功，请重新登录");
                }
                this.dialogLoading = false;
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            tableOpt() {
            },
        }
    }
</script>
